function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Table, Column, AutoSizer } from 'react-virtualized';
import './LinksTable.css';

var LinksTable = /*#__PURE__*/function (_React$Component) {
  _inherits(LinksTable, _React$Component);

  var _super = _createSuper(LinksTable);

  function LinksTable() {
    var _this;

    _classCallCheck(this, LinksTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnRowClick", function (_ref) {
      var rowData = _ref.rowData;
      var onLinkClick = _this.props.onLinkClick;
      onLinkClick(rowData);
    });

    return _this;
  }

  _createClass(LinksTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var links = this.props.links;
      var headerClassName = 'mid-gray fw2 tracked silver';
      var rowHeight = 29;
      var headerHeight = 32;
      var tableHeight = Math.max(370, Math.min(window.innerHeight - 500, links.length * rowHeight + headerHeight));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AutoSizer, {
        disableHeight: true
      }, function (_ref2) {
        var width = _ref2.width;
        return /*#__PURE__*/React.createElement(Table, {
          className: "tl fw4 LinksTable",
          rowClassName: "pointer bb b--near-white f7",
          width: width,
          height: tableHeight,
          headerHeight: 32,
          rowHeight: rowHeight,
          rowCount: links.length,
          rowGetter: function rowGetter(_ref3) {
            var index = _ref3.index;
            return _objectSpread({
              index: index
            }, links[index]);
          },
          onRowClick: _this2.handleOnRowClick
        }, /*#__PURE__*/React.createElement(Column, {
          dataKey: "index",
          width: 34,
          className: "pv2 silver monospace tr pr1"
        }), /*#__PURE__*/React.createElement(Column, {
          label: "Path",
          dataKey: "path",
          width: 210,
          flexGrow: 1,
          className: "pv2 navy f6-ns",
          headerClassName: headerClassName
        }), /*#__PURE__*/React.createElement(Column, {
          label: "CID",
          dataKey: "target",
          width: 360,
          className: "pv2 mid-gray monospace",
          headerClassName: headerClassName
        }));
      }));
    }
  }]);

  return LinksTable;
}(React.Component);

export default LinksTable;